/** Runtime configuration from Vite env vars (see .env.example). */
export const config = {
  apiUrl: (import.meta.env.VITE_API_URL as string | undefined)?.replace(/\/$/, '') ?? '',
  region: (import.meta.env.VITE_AWS_REGION as string | undefined) ?? '',
  userPoolId: (import.meta.env.VITE_COGNITO_USER_POOL_ID as string | undefined) ?? '',
  clientId: (import.meta.env.VITE_COGNITO_CLIENT_ID as string | undefined) ?? '',
  engineerDomain: (import.meta.env.VITE_ENGINEER_EMAIL_DOMAIN as string | undefined) ?? 'seldon.global',
}

export const isConfigured = Boolean(config.apiUrl && config.userPoolId && config.clientId)
